import React from 'react';
import CommonInput from './CommonInput';
import CommonTextarea from './CommonTextarea';

const ItemInput = ({ 
    index, 
    field, 
    value, 
    onChange, 
    disabled, 
    errors,
    className = "mb-0",
    type = "text",
    required = false,
    displayError = true,
    arrayName = "items",
    rows = 1,
}) => {
    // Convert array index error to field-specific error
    const getFieldError = () => {
        const errorKey = `${arrayName}.${index}.${field}`;
        if (errors?.[errorKey]) {
            return Array.isArray(errors[errorKey]) ? errors[errorKey][0] : errors[errorKey];
        }
        return null;
    };

    // Create a modified errors object with the specific field error
    const fieldErrors = {
        [`${arrayName}[${index}].${field}`]: getFieldError()
    };

    return (
        <>
        { type === 'textarea' ? (
            <CommonTextarea
                className={className}
                name={`${arrayName}[${index}].${field}`}
                value={value}
                onChange={onChange}
                disabled={disabled}
                errors={fieldErrors}
                type={type}
                required={required}
                displayError={displayError}
                rows={rows}
            />
        ) : (
            <CommonInput
            className={className}
            name={`${arrayName}[${index}].${field}`}
            value={value}
            onChange={onChange}
            disabled={disabled}
            errors={fieldErrors}
            type={type}
            required={required}
            displayError={displayError}
        />
        )}
        </>
    );
};

export default ItemInput; 